import { message } from 'antd';
import { useCallback } from 'react';
import { useStore } from '@stores';
import { Inventory, DispachedServicePart } from '@services';

interface PartContext {
  registrationNumber?: string;
  vin?: string;
  orderId?: string;
  masterBuildId?: string;
  buildReference?: string;
}

export const useAddToPurchaseOrder = () => {
  const { purchaseOrderStore } = useStore();

  const addFromPart = useCallback(
    async (part: DispachedServicePart, ctx: PartContext = {}, qty: number) => {
      await purchaseOrderStore.create({
        partName: part.name,
        partNumber: part.number ?? undefined,
        reference: part.reference ?? undefined,
        quantity: qty,
        inventoryId: part.inventoryId ?? undefined,
        registrationNumber: ctx.registrationNumber,
        vin: ctx.vin,
        orderId: ctx.orderId,
        masterBuildId: ctx.masterBuildId,
        buildReference: ctx.buildReference,
      });
      message.success(`"${part.name}" added to purchase orders`);
    },
    [purchaseOrderStore],
  );

  const addFromInventory = useCallback(
    async (record: Inventory, qty: number) => {
      await purchaseOrderStore.create({
        partName: record.name,
        partNumber: record.partNumber ?? undefined,
        reference: record.reference ?? undefined,
        quantity: qty,
        inventoryId: record.id,
        supplierId: record.supplierId ?? undefined,
      });
      message.success(`"${record.name}" added to purchase orders`);
    },
    [purchaseOrderStore],
  );

  return { addFromPart, addFromInventory };
};
